/* eslint-disable @hakio/no-untranslated-terminology -- flag panel copy is internal (staff-only), not tenant-facing */
import {
  flagName,
  type FlagCategory,
  type FlagDefinition,
  type FlagEnvironment,
} from "~/features/feature-flags/shared/registry"

export const ENVIRONMENT_LABELS: Record<FlagEnvironment, string> = {
  production: "Production",
  demo: "Demo",
  test: "Test",
}

export const CATEGORY_LABELS: Record<FlagCategory, string> = {
  module: "Module",
  custom: "Custom",
  concierge: "Concierge",
  release: "Release",
  ops: "Ops",
}

export const CATEGORY_DESCRIPTIONS: Record<FlagCategory, string> = {
  module: "Modules and pages a company has. Permanent.",
  custom: "Built for one or a few companies. Never turned on for others.",
  concierge: "Rolled out company by company by Customer Success.",
  release: "Released to every customer at once. Removed after release.",
  ops: "Technical and operational switches. Permanent.",
}

export const blockedByReason = (prerequisite: string) =>
  `Off because ${flagName(prerequisite)} is off.`

/** "Needs Demand plan": the short form of `blockedByReason`, for a Source cell. */
export const needsLabel = (prerequisite: string) => `Needs ${flagName(prerequisite)}`

export const onOffLabel = (value: boolean) => (value ? "On" : "Off")

export type TargetNoun = "company" | "user"

const NOUN_PLURALS: Record<TargetNoun, string> = { company: "companies", user: "users" }

/** "1 company", "3 companies": a count with its noun, agreeing in number. */
export const countTargets = (count: number, noun: TargetNoun) =>
  `${count} ${count === 1 ? noun : NOUN_PLURALS[noun]}`

export type FlagReview = {
  /** "YYYY-MM-DD", from the registry. */
  date: string
  warning: string | null
}

/** A custom flag's review date, with a warning once it has passed. Null for other categories. */
export const flagReview = (definition: FlagDefinition, today: string): FlagReview | null =>
  definition.category === "custom"
    ? {
        date: definition.reviewBy,
        warning: definition.reviewBy < today ? "The review date has passed." : null,
      }
    : null
